<span data-cy="alarm-icon" [class]="'icon '+ getClass()"></span>